import { defineComponent as _defineComponent } from 'vue'
import { computed, watchEffect } from "@nuxtjs/composition-api";

import { useTranslate, useVuetify } from "@/composables";
import { useCartsStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsNotification',
  emits: ["view"],
  setup(__props, { emit }: { emit: ({
  (e: "view", cartId: string): void;
}), expose: any, slots: any, attrs: any }) {



const { t } = useTranslate();
const vuetify = useVuetify();
const cartsStore = useCartsStore();

const notification = computed(() => {
  return cartsStore.notification;
});

const showNotification = computed(() => {
  if (!notification.value) {
    return false;
  }

  // If the user succesfully added a cart item and is on a non-mobile device, then do not show the notification.
  if (isSuccess.value && vuetify.breakpoint.smAndUp) {
    return false;
  }

  return true;
});

const cart = computed(() => {
  if (!notification.value?.cartId) {
    return;
  }
  return cartsStore.carts[notification.value.cartId];
});

const retailerName = computed(() => {
  const retailerId = cart.value?.retailerId;
  if (retailerId) {
    return cartsStore.retailers[retailerId]?.displayName;
  }
});

const isSuccess = computed(() => {
  return Boolean(notification.value?.type === "added" && notification.value.cartId);
});

const message = computed(() => {
  if (!notification.value) {
    return "";
  }

  switch (notification.value.type) {
    case "added": {
      return t("Item was added to your cart").value;
    }
    case "added-error": {
      return t("There was an error when adding to cart. Please try again.").value;
    }
    case "updated-error": {
      return t("There was an error when updating your cart. Please try again.").value;
    }
    case "max-error": {
      return t("Maximum quantity for {retailerName} has been reached.", {
        retailerName: retailerName.value ?? "retailer",
      }).value;
    }
    case "checkout-error": {
      return t("Oops, something went wrong! We’re on it — try again later.").value;
    }
  }
});

watchEffect(() => {
  if (!notification.value || vuetify.breakpoint.xsOnly) {
    return;
  }

  // For non-mobile breakpoints, open the cart drawer after succesfully adding a cart item.
  if (isSuccess.value) {
    emit("view", notification.value.cartId ?? "");
    cartsStore.notification = null;
  }
});

const onViewCart = () => {
  if (!notification.value?.cartId) {
    return;
  }
  emit("view", notification.value.cartId);
  cartsStore.notification = null;
};

const onHideNotification = () => {
  cartsStore.notification = null;
};

return { __sfc: true,emit, t, vuetify, cartsStore, notification, showNotification, cart, retailerName, isSuccess, message, onViewCart, onHideNotification }
}

})